import styled from "styled-components";
import { Icon, Text } from "@amzn/storm-ui";

export const MobileSheetContentContainer = styled.div`
  background-color: ${({ theme }) => theme.palette.gray[10]};
`;
export const MobileCloseBtnContainer = styled.div`
  background-color: ${({ theme }) => theme.palette.gray[50]};
  box-shadow: inset 0px -1px 0px ${({ theme }) => theme.palette.gray[200]};
  padding: 4px;
`;
export const MobileListComponentContainer = styled.div`
  border-top: 1px solid rgb(231, 231, 231);
`;
export const MobileCloseIcon = styled(Icon)`
  color: ${({ theme }) => theme.palette.boulder};
`;
export const MobileCloseBtnText = styled.strong`
  padding-left: ${({ theme }) => theme.spacing.small};
`;
export const DesktopSelectorComponentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
`;
export const DesktopSelectorComponentLabel = styled(Text)`
  padding-top: 12px;
  padding-inline-start: 20px;
`;
export const DesktopEmptyListLabel = styled(Text)`
  padding-top: 100px;
  text-align: center;
`;
export const DesktopListComponentContainer = styled.div`
  overflow-y: auto;
`;